var _rect, _rect2, _path, _g, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38477)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1322_38477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 11,
    width: 33,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3009 11H14V48.3478H46.3009V11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1322_38477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0994 47.8751L21.6264 44.9199L18.6641 45.3602L19.1055 48.3465L22.0994 47.8751Z",
    fill: "url(#paint0_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.577 39.5136L45.104 36.5273L31.9316 38.5709L32.4046 41.5261L45.577 39.5136Z",
    fill: "url(#paint1_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7391 42.2494L30.7014 41.8091L30.26 38.8223L27.2666 39.2626L27.7391 42.2494Z",
    fill: "url(#paint2_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7629 47.1841L26.2904 44.1973L23.3281 44.6692L23.7695 47.6244L26.7629 47.1841Z",
    fill: "url(#paint3_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9385 40.7082L18.3799 43.6945L21.3732 43.2232L20.9008 40.2363L17.9385 40.7082Z",
    fill: "url(#paint4_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6562 43.2229L33.1287 46.2091L46.3016 44.1656L45.8286 41.2109L32.6562 43.2229Z",
    fill: "url(#paint5_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4637 46.9017L31.426 46.4614L30.9846 43.4746L27.9912 43.9465L28.4637 46.9017Z",
    fill: "url(#paint6_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6025 39.9852L23.075 42.9715L26.0373 42.5001L25.5965 39.5449L22.6025 39.9852Z",
    fill: "url(#paint7_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9159 38.8215L15.2604 15.0234L14 15.2121L17.6871 39.0417L18.9159 38.8215Z",
    fill: "url(#paint8_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6807 38.5707L16.7097 12.9805L15.4492 13.2005L19.3886 38.7592L20.6807 38.5707Z",
    fill: "url(#paint9_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6114 38.1305L19.4519 11L18.1914 11.1886L22.351 38.319L23.6114 38.1305Z",
    fill: "url(#paint10_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3439 37.8467L21.531 13.1367L20.2705 13.3254L24.0835 38.0352L25.3439 37.8467Z",
    fill: "url(#paint11_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2761 37.4064L24.904 15.4316L23.6436 15.6202L27.0157 37.595L28.2761 37.4064Z",
    fill: "url(#paint12_linear_1322_38477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0088 37.1241L26.4792 14.332L25.2188 14.5206L28.7483 37.3127L30.0088 37.1241Z",
    fill: "url(#paint13_linear_1322_38477)"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1322_38477",
    x1: 21.8089,
    y1: 55.9261,
    x2: 14.826,
    y2: 10.4419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1322_38477",
    x1: 40.9123,
    y1: 52.9944,
    x2: 33.9299,
    y2: 7.51032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1322_38477",
    x1: 31.1488,
    y1: 54.4937,
    x2: 24.1659,
    y2: 9.00928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1322_38477",
    x1: 26.4779,
    y1: 55.21,
    x2: 19.495,
    y2: 9.72557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1322_38477",
    x1: 21.8048,
    y1: 55.9274,
    x2: 14.8225,
    y2: 10.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1322_38477",
    x1: 40.9127,
    y1: 52.9937,
    x2: 33.9298,
    y2: 7.50954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1322_38477",
    x1: 31.147,
    y1: 54.4933,
    x2: 24.1641,
    y2: 9.00917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1322_38477",
    x1: 26.4765,
    y1: 55.2104,
    x2: 19.4942,
    y2: 9.72611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1322_38477",
    x1: 20.8085,
    y1: 55.1758,
    x2: 14.1864,
    y2: 12.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1322_38477",
    x1: 22.7253,
    y1: 56.1064,
    x2: 15.6149,
    y2: 9.79147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1322_38477",
    x1: 25.8468,
    y1: 56.7032,
    x2: 18.308,
    y2: 7.59662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1322_38477",
    x1: 27.3259,
    y1: 54.8037,
    x2: 20.4531,
    y2: 10.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1322_38477",
    x1: 29.9572,
    y1: 52.473,
    x2: 23.8517,
    y2: 12.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1322_38477",
    x1: 31.7777,
    y1: 52.7814,
    x2: 25.4384,
    y2: 11.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow25);
export default __webpack_public_path__ + "static/media/row-2-5.2c7c74c82ebb10528fe8a7fe7c6921b2.svg";
export { ForwardRef as ReactComponent };